import { B_RealEstateFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import HTransformObject from "@rf-helper/transform-object.helper";
import { createProjectPayloadAdapter } from "./create-project-property-adapter";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";

const UpdatePropertyProjectAdapter: ICreatePropertyAdapter = (
  state: IPropertyForm,
  originalState: IPropertyForm
) => {
  const stateDirty = prePrepareBuilding(state, originalState);
  const payloadDirty = createProjectPayloadAdapter({ ...state, ...stateDirty });

  return HTransformObject(payloadDirty, {
    removeUndefined: true,
    removeEmptyArray: true,
    removeNull: true,
    removeEmptyStrings: true,
    removeEmptyObjects: true
  });
};

type ICreatePropertyAdapter = (
  state: IPropertyForm,
  originalState: IPropertyForm
) => B_RealEstateFormCreateBody;

export default UpdatePropertyProjectAdapter;

const prePrepareBuilding = (
  state: IPropertyForm,
  originalState: IPropertyForm
): Pick<IPropertyForm, "building" | "buildingsDeleted" | "unitsDeleted"> => {
  const {
    building: currentBuildings = [],
    buildingsDeleted = [],
    unitsDeleted = []
  } = state;
  const { building: originalBuildings = [] } = originalState;

  // Filtra buildings eliminados
  const filteredCurrentBuildings = currentBuildings.filter(
    building => !buildingsDeleted.includes(building.id)
  );

  // Detecta cambios en buildings y units
  const modifiedBuildings = filteredCurrentBuildings
    .map(currentBuilding => {
      const originalBuilding = originalBuildings.find(
        b => b.id === currentBuilding.id
      );

      // Si no existe en original, es nuevo
      if (!originalBuilding) {
        console.log(`[building][NEW] id=${currentBuilding.id}`, currentBuilding);
        return currentBuilding;
      }

      // Compara props del building (excepto units)
      const buildingChanged = Object.keys(currentBuilding).some(key => {
        if (key === "units") return false;
        return (
          JSON.stringify(currentBuilding[key as keyof typeof currentBuilding]) !==
          JSON.stringify(originalBuilding[key as keyof typeof originalBuilding])
        );
      });

      // Filtra units eliminadas
      const currentUnits = (currentBuilding.units || []).filter(
        unit => !unitsDeleted.includes(unit.id)
      );

      const originalUnits = originalBuilding.units || [];

      // Detecta units nuevas o modificadas
      const modifiedUnits = currentUnits.filter(currentUnit => {
        const originalUnit = originalUnits.find(u => u.id === currentUnit.id);
        if (!originalUnit) {
          console.log(
            `[unit][NEW] buildingId=${currentBuilding.id} unitId=${currentUnit.id}`,
            currentUnit
          );
          return true; // Nueva
        }
        const changed = Object.keys(currentUnit).some(
          key =>
            JSON.stringify(currentUnit[key as keyof typeof currentUnit]) !==
            JSON.stringify(originalUnit[key as keyof typeof originalUnit])
        );
        if (changed) {
          console.log(
            `[unit][MODIFIED] buildingId=${currentBuilding.id} unitId=${currentUnit.id}`,
            { before: originalUnit, after: currentUnit }
          );
        }
        return changed;
      });

      if (buildingChanged) {
        console.log(`[building][MODIFIED] id=${currentBuilding.id}`, {
          before: originalBuilding,
          after: currentBuilding
        });
      }

      if (buildingChanged || modifiedUnits.length > 0) {
        // Solo retorna las units modificadas
        return { ...currentBuilding, units: modifiedUnits };
      }
      return null;
    })
    .filter((b): b is NonNullable<typeof b> => !!b);

  // Log resumen final
  if (modifiedBuildings.length === 0) {
    console.log("No hay buildings ni units modificados");
  } else {
    console.log(
      "Buildings modificados:",
      modifiedBuildings.map(b => b.id)
    );
  }

  return {
    building: modifiedBuildings,
    buildingsDeleted,
    unitsDeleted
  };
};
